import { ReserveLists } from "admin-panel/reservation/Tabs";
import { ReservationContextProvider } from "admin-panel/reservation/ReservationContext";
import { ModalContextProvider } from "admin-panel/reservation/ModalContext";
import { EditModals } from "admin-panel/reservation/Modals";
export default function TourOrdersTab({ userId }) {
  return (
    <div class="tab-pane fade  w-100" id="tour-orders">
      <ReservationContextProvider uid={userId}>
        <ModalContextProvider>
          <EditModals justShow></EditModals>
          <ReserveLists order></ReserveLists>
        </ModalContextProvider>
      </ReservationContextProvider>
    </div>
  );
}
